class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => { this.onSubmitHandler(event); }, 500);

    const facetForm = this.querySelector('form');
    if (!facetForm) return;

    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
    // Add listener for size change to update available colors
    const sizeSelector = facetForm.querySelector('select[name="size"]');
    if (sizeSelector) {
      sizeSelector.addEventListener('change', this.updateSwatchesBasedOnSize.bind(this));
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        // hide out of stock color-size swatches
        if (url.includes("main-collection")) {
          hideOOSColorSwatchFilteredSize();

        }
        FacetFiltersForm.renderProductCount(html);

      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    // hide out of stock color-size swatches
    if (FacetFiltersForm.filterData.find(filterDataUrl).url.includes("main-collection")) {
      hideOOSColorSwatchFilteredSize();

    }
    FacetFiltersForm.renderProductCount(html);
  }
 static scrollToProductsContainer() {
    const section = document.querySelector('.products-container');
    if (!section) return;
    const testVersionB = document.querySelector('.PLP-test-B');
    const isDesktop = window.innerWidth > 768;
    if (typeof testVersionB !== 'undefined' && testVersionB && isDesktop) {
      return;
    }
    const rect = section.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const offsetTop = rect.top + scrollTop;

    const extraOffset = window.innerWidth <= 768 ? 170 : 100;

    window.scrollTo({
      top: offsetTop - extraOffset,
      behavior: 'smooth'
    });
  }


  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    productCardColorUpdateFunction();
    productCardColorSwatchesScroll();
    checkActiveFacetsMobile();
    ensureActiveSwatchPerCard();
    initProductCardVideos();
    FacetFiltersForm.scrollToProductsContainer();
    setTimeout(moveCollectionAdFixed, 50);
  }

  static renderProductCount(html) {
    let count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    const containerDesktopFilters = document.getElementById('ProductCountDesktopFilters');

    const extraHiddenProducts = document.querySelectorAll('.product-card:has(.color-swatch.active.size-hidden)');
    if (extraHiddenProducts.length > 0) {
      let productsCount = parseInt(count.match(/\d+/)[0], 10);
      productsCount -= extraHiddenProducts.length;
      count = count.replace(/\d+/, productsCount);
    }

    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    if (containerDesktopFilters) {
      containerDesktopFilters.innerHTML = count;
      containerDesktopFilters.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.mobile-facets__wrapper--A .active-facets-mobile', '.mobile-facets__wrapper--B .active-facets-mobile', '.active-facets-desktop', '.active-facets-desktop-A'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    const m = document.getElementById('FacetFiltersFormMobile');
    const drawer = m && m.closest ? m.closest('menu-drawer') : null;
    if (drawer && typeof drawer.bindEvents === 'function') drawer.bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);

    if (!formData.get('filter.v.price.gte')) formData.delete('filter.v.price.gte');
    if (!formData.get('filter.v.price.lte')) formData.delete('filter.v.price.lte');

    return new URLSearchParams(formData).toString();
  }


  onSubmitForm(searchParams, event) {
    let searchParamsUpdated = searchParams;
    FacetFiltersForm.renderPage(searchParamsUpdated, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement && event.srcElement.classList && event.srcElement.classList.contains('mobile-facets__checkbox')) {
      const form = event.target.closest('form');
      if (!form) return;
      const searchParams = this.createSearchParams(form);
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const formEl = event.target.closest('form');
      const isMobile = formEl && formEl.id === 'FacetFiltersFormMobile';
      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }


  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

}


async function applySwatch(card, swatchEl) {
  if (!card || !swatchEl) return;

  const swatchColor = swatchEl.getAttribute('data-color');
  const productHandle = card.getAttribute('data-product-handle');
  const url = `/products/${productHandle}.js`;

  const imgWrap = card.querySelector('.product-card__image .image-container');
  const colorLabel = card.querySelector('.product-card__variant-color');
  const links = card.querySelectorAll('.product-card__link');

  const data = await fetch(url).then(r => r.json()).catch(() => null);
  if (!data) return;

  // Find matching variant w/ featured image
  const variant = (data.variants || []).find(v => v.option1 === swatchColor && v.featured_image && v.featured_image.src);
  if (!variant) return;

  // 1) active class
  card.querySelectorAll('.color-swatch').forEach(el => el.classList.remove('active'));
  swatchEl.classList.add('active');

  // 2) label
  if (colorLabel) colorLabel.textContent = swatchColor;

  // 3) update links (?variant=ID) robustly
  links.forEach(link => {
    try {
      const u = new URL(link.href, window.location.origin);
      u.searchParams.set('variant', variant.id);
      link.href = u.pathname + u.search;
    } catch (_) {}
  });

  // 4) rebuild images for this color
  if (imgWrap) {
    const buildImg = (src, cls) => {
      const i = src.lastIndexOf('.');
      const base = src.slice(0, i);
      const ext  = src.slice(i);
      return `
        <img 
          src="${base}_800x${ext}"
          alt="${swatchColor}"
          srcset="${base}_180x${ext} 180w,
                  ${base}_360x${ext} 360w,
                  ${base}_540x${ext} 540w,
                  ${base}_720x${ext} 720w,
                  ${base}_800x${ext} 800w"
          class="${cls}"
          sizes="(min-width: 1700px) 395px,(min-width: 990px) calc((100vw - 120px) / 4), (min-width: 750px) calc((100vw - 80px) / 2), calc(100vw / 2)">
      `;
    };

    // featured
    imgWrap.innerHTML = buildImg(variant.featured_image.src, 'image-cover');

    // gallery for this color (skip featured)
    (data.media || []).forEach(m => {
      if (m.media_type === 'image' && m.alt === swatchColor && (!variant.featured_media || m.id !== variant.featured_media.id)) {
        imgWrap.insertAdjacentHTML('beforeend', buildImg(m.src, 'image-cover hide-hover'));
      }
    });
    imgWrap.scrollLeft = 0;
  }

  // 5) (optional) pull price snippet for this color in collections
  if (location.pathname.includes('/collections')) {
    const sec = card.getAttribute('data-section-id');
    if (sec) {
      const colorURL = `${location.pathname}?section_id=${sec}&filter.v.option.color=${encodeURIComponent(swatchColor)}`;
      const html = await fetch(colorURL).then(r => r.text()).catch(() => null);
      if (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector(`.product-card[data-product-handle="${productHandle}"]`);
        const priceD = fresh && fresh.querySelector('.product-card__price');
        const priceM = fresh && fresh.querySelector('.product-card__price--mobile');
        const hereD  = card.querySelector('.product-card__price');
        const hereM  = card.querySelector('.product-card__price--mobile');
        if (hereD && priceD) hereD.innerHTML = priceD.innerHTML;
        if (hereM && priceM) hereM.innerHTML = priceM.innerHTML;
      }
    }
  }
}

(function bindDelegatedSwatchClicks(){
  if (window._swatchDelegationBound) return;
  window._swatchDelegationBound = true;

  document.addEventListener('click', (e) => {
    const swatch = e.target.closest('.color-swatch');
    if (!swatch) return;
    const card = swatch.closest('.product-card');
    if (!card) return;
    if (swatch.classList.contains('active')) return;
    applySwatch(card, swatch);
  });
})();


const hideOOSColorSwatchFilteredSize = function () {
  // Check if the '.main-last-chance' section exists
  const mainLastChanceSection = document.querySelector('.main-last-chance');

  // Only proceed if the '.main-last-chance' class exists
  if (mainLastChanceSection) {
    const params = new URLSearchParams(window.location.search);
    const filteredSizes = params.getAll('filter.v.option.size');  // Get all selected sizes (e.g., 'XL', 'M', 'L')

    if (filteredSizes.length > 0) {
      const renderedProducts = document.querySelectorAll('.product-card');

      renderedProducts.forEach(product => {
        let oosVariants = product.dataset.oosVariants;
        let productHasVisibleSwatches = false;

        if (oosVariants) {
          // Process the variants string into individual color/size pairs
          oosVariants = oosVariants.split(" ,").map(str => str.trim()).filter(Boolean);
          const oosColors = new Set();  // To store unique colors that are out of stock for the filtered size(s)
          const inStockColors = new Set(); // To store colors with available stock

          oosVariants.forEach(variant => {
            const [color, size] = variant.split(" / ").map(s => s.trim()).slice(0, 2);

            if (filteredSizes.includes(size)) { // Check for any of the selected sizes
              const colorSwatch = product.querySelector(`.color-swatch[data-color="${color}"]`);
              
              // Check if the product has this color in stock or out of stock for the selected size
              if (colorSwatch) {
                if (filteredSizes.some(size => oosVariants.includes(`${color} / ${size}`))) {
                  oosColors.add(color); // Add to out of stock colors if the selected size is out of stock
                } else {
                  inStockColors.add(color);  // Add color to available colors
                }
              }
            }
          });

          // For each out of stock color, hide the swatch
          product.querySelectorAll('.color-swatch').forEach(swatch => {
            const color = swatch.dataset.color;

            // If the color is out of stock for the selected size, hide the swatch
            if (oosColors.has(color)) {
              swatch.classList.add('size-hidden');
            }
          });

          // If no colors are in stock for the selected size, hide the product
          if (inStockColors.size === 0) {
            product.style.display = 'none';  // Hide product if no swatches match the selected sizes
          } else {
            product.style.display = ''; // Show product if any color is in stock for the selected size
          }
        }
      });
    }
  }
};

function ensureActiveSwatchPerCard() {
  document.querySelectorAll('.product-card').forEach(card => {
    const wrap = card.querySelector('.last-chance__swatches') || card.querySelector('.product-card__color-swatches');
    if (!wrap) return;

    // if something is already active & visible, do nothing
    const alreadyActive = wrap.querySelector('.color-swatch.active:not(.size-hidden):not(.hidden)');
    if (alreadyActive) return;

    // else pick the first visible swatch
    const visible = [...wrap.querySelectorAll('.color-swatch')].filter(s =>
      !s.classList.contains('size-hidden') &&
      !s.classList.contains('hidden') &&
      s.offsetParent !== null
    );

    if (visible.length) applySwatch(card, visible[0]);
  });
}


// Click a swatch when none is active (Last Chance only). Hide card if no visible swatches exist.
const checkAndActivateSwatch = function () {
  document
    .querySelectorAll('.product-card__color-swatches-container .last-chance__swatches')
    .forEach(wrap => {
      // If any swatch is already active, do nothing
      if (wrap.querySelector('.color-swatch.active')) return;

      // Only consider swatches that are actually visible
      const visible = Array.from(wrap.querySelectorAll('.color-swatch'))
        .filter(s => !s.classList.contains('size-hidden') &&
                     !s.classList.contains('hidden') &&
                     s.offsetParent !== null);

      if (visible.length > 0) {
        const target = visible[0];
        // Dispatch click (some themes listen on the inner div)
        const clickable = target.querySelector('.color-swatch__inner') || target;
        setTimeout(function(){
                  clickable.dispatchEvent(new MouseEvent('click', { bubbles: true }));
        }, 500);
        // Force the visual state immediately so UI updates without delay
        target.classList.add('active');
      }
    });
};



// Call the function to apply the logic
hideOOSColorSwatchFilteredSize();


FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

const checkActiveFacetsMobile = function () {
  const activeFacetsMobile = document.querySelector('.active-facets-mobile');
  if (!activeFacetsMobile) return;
  const activeFacetsMobileContent = activeFacetsMobile.querySelector('.active-facets-mobile__body');

  if (activeFacetsMobileContent.textContent) activeFacetsMobile.classList.remove('hidden');
  else activeFacetsMobile.classList.add('hidden');
}

checkActiveFacetsMobile();

document.addEventListener('DOMContentLoaded', () => {
  ensureActiveSwatchPerCard();
});

function moveCollectionAdFixed() {
  const grid = document.querySelector("#product-grid");
  if (!grid) return;

  const ad = grid.querySelector(".collection-ad");
  if (!ad) return;

  const items = Array.from(grid.children).filter(
    el => !el.classList.contains("collection-ad")
  );

  // If fewer than 6 products → do nothing
  if (items.length < 6) return;

  ad.remove();

  if (items[5]) {
    grid.insertBefore(ad, items[5]);
  } else {
    grid.appendChild(ad);
  }
}
